import axios from 'axios';

const GOOGLE_ALBUM_API_REST_ENDPOINT = `https://photoslibrary.googleapis.com/v1`;
const SERVER_URL = `${process.env.REACT_APP_GOOGLE_OAUTH_ENDPOINT}/api`;

export async function uploadImage(extension: string, imageData: ArrayBuffer): Promise<string> {
  const accessToken = await getAdminToken();
  try {
    const response = await axios.post(`${GOOGLE_ALBUM_API_REST_ENDPOINT}/uploads`, imageData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-type': 'application/octet-stream',
        'X-Goog-Upload-Content-Type': extension,
        'X-Goog-Upload-Protocol': 'raw',
      },
    });
    return response.data;
  } catch (error: any) {
    console.log('error: ', error);
    return '';
  }
}

async function getAdminToken(): Promise<string> {
  try {
    const response = await axios.get(`${SERVER_URL}/admin/token`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    console.log('error: ', error);
    return '';
  }
}
